export const SET_USER = 'SET_USER';
export const RESET_USER = 'RESET_USER';

const setUser = (user, msalInstance) => {
  return {
    type: SET_USER,
    payload: {
      user,
      msalInstance
    }
  };
};

const resetUser = () => {
  return {
    type: RESET_USER,
    payload: null
  };
};

const authAction = {
  setUser,
  resetUser
};

export default authAction;
